export async function PalPlugin() {
  return new Promise((resolve, reject) => {
    if (!window.goog || !window.goog.pal) return reject("PAL SDK not loaded?");

    try {
      const consentSettings = new goog.pal.ConsentSettings();
      consentSettings.allowStorage = true;

      const nonceLoader = new goog.pal.NonceLoader(consentSettings);

      const request = new goog.pal.NonceRequest();
      request.adWillAutoPlay = true;
      request.adWillPlayMuted = false;
      request.continuousPlayback = false;
      request.descriptionUrl = location.origin;
      request.iconsSupported = false;
      request.playerType = "shaka";
      request.playerVersion = '1.0.14';
      request.ppid = "PPID";
      request.sessionId = "SID";
      request.supportedApiFrameworks = "2,9";
      request.url = location.origin + location.pathname;
      request.videoHeight = 1920;
      request.videoWidth = 1080;

      nonceLoader
        .loadNonceManager(request)
        .then((manager) => {
          const nonce = manager.getNonce();
          console.log("PAL Nonce generated");
          resolve(nonce);
        })
        .catch((error) => {
          console.error(error);
          reject(error);
        });
    } catch (e) {
      reject(e);
    }
  });
}